import React from "react";
import PropTypes from "prop-types";
import Ad from "components/Library/Ad";
import Lazyload from "components/Library/Lazyload";

const StreamAd = ({ node }) => {
  return (
    /* Immediately load the first ad based on its pos name */
    <Lazyload loadImmediately={node.targeting.pos === "mid1"}>
      <Ad
        adUnit={node.adUnit}
        slotSize="fluid"
        renderWhenViewable={false}
        collapseEmptyDiv={true}
        targeting={node.targeting}
      />
    </Lazyload>
  );
};

StreamAd.propTypes = {
  node: PropTypes.shape({
    adUnit: PropTypes.string.isRequired,
    targeting: PropTypes.shape({
      pos: PropTypes.string,
    }).isRequired,
  }).isRequired,
};

export default StreamAd;
